import { Component } from '@angular/core';

import { NceService } from '../services/nce.service';
import { FileService } from '../../shared/services/file.service';

import { StorageService } from './../../shared/services/storage.service';
import { PageNavigationService } from '../../shared/services/page-navigation.service';
import { LayoutService } from '../../shared/services/layout.service';

@Component({
    selector: 'nce-preview',
    templateUrl: '../../shared/components/preview/preview-parent.component.html'
})
export class NcePreviewComponent{

    constructor(
        private _nceService: NceService,
        private _fileService: FileService,
        private _layoutService: LayoutService,
        private _storageService: StorageService,
        private _pageNavigationService: PageNavigationService
    ) { }

    /*obj = { }

    vData = {
        status : "Waiting Payment",
        appointment : false,
        data: {
            nce_data: this.obj,
            attachment: this._fileService.getFileLists(),
            earthwork_remarks: this._nceService.getEarthworkRemarks()
        },
        buttons : {
            CANCEL: {
                text: 'Back',
                function: () => {
                    this._pageNavigationService.navigate(['nce-application/declaration']);
                }
            },
            OK: {
                text: 'Payment',
                function: () => {
                    this._pageNavigationService.navigate(['nce-application/payment']);
                }
            }
        }
    }*/

    vNCEid = 0;

    ngOnInit() {
        this._layoutService.setCurrentPage('nce-preview');
        this._nceService.vDetailNCE = {
            nce_record_id: this._nceService.getFillInParticulars().nce_record_id,
            nce_request_id: this._nceService.getFillInParticulars().nce_request_id,
            nce_reference_id: this._nceService.getFillInParticulars().nce_reference_id,
            prev_request_id: this._nceService.getFillInParticulars().prev_request_id,
            plant_record_id: this._nceService.getFillInParticulars().plant_record_id,
            plant_request_id: this._nceService.getFillInParticulars().plant_request_id,
            supervisor_name: this._nceService.getFillInParticulars().supervisor_name,
            supervisor_nric: this._nceService.getFillInParticulars().supervisor_nric,
            supervisor_tel: this._nceService.getFillInParticulars().supervisor_tel,
            supervisor_mobile: this._nceService.getFillInParticulars().supervisor_mobile,
            contract_principal: this._nceService.getFillInParticulars().contract_principal,
            contract_officer: this._nceService.getFillInParticulars().contract_officer,
            contract_tel: this._nceService.getFillInParticulars().contract_tel,
            contract_mobile: this._nceService.getFillInParticulars().contract_mobile,
            contract_start: this._nceService.getFillInParticulars().contract_start,
            contract_end: this._nceService.getFillInParticulars().contract_end,
            contract_no: this._nceService.getFillInParticulars().contract_no,
            contract_work_order: this._nceService.getFillInParticulars().contract_work_order,
            contract_company_name: this._nceService.getFillInParticulars().contract_company_name,
            contract_contact_number: this._nceService.getFillInParticulars().contract_contact_number,
            contract_contact_person: this._nceService.getFillInParticulars().contract_contact_person,
            tcdw_name: this._nceService.getFillInParticulars().tcdw_name,
            tcdw_nric: this._nceService.getFillInParticulars().tcdw_nric,
            tcdw_tel: this._nceService.getFillInParticulars().tcdw_tel,
            tcdw_mobile: this._nceService.getFillInParticulars().tcdw_mobile,
            tcdw_license: this._nceService.getFillInParticulars().tcdw_license,
            tcdw_expiry_date: this._nceService.getFillInParticulars().tcdw_expiry_date,

            contractor_company_address: this._nceService.getFillInParticulars().contractor_company_address,
            contractor_company_name: this._nceService.getFillInParticulars().contractor_company_name,
            contractor_company_reg_no: this._nceService.getFillInParticulars().contractor_company_reg_no,
            contractor_first_name: this._nceService.getFillInParticulars().contractor_first_name,
            contractor_last_name: this._nceService.getFillInParticulars().contractor_last_name,
            contractor_telephone_no: this._nceService.getFillInParticulars().contractor_telephone_no,
            contractor_designation: this._nceService.getFillInParticulars().contractor_designation,
            contractor_email: this._nceService.getFillInParticulars().contractor_email,
            contractor_mobile_no: this._nceService.getFillInParticulars().contractor_mobile_no,
            contractor_contact_person: this._nceService.getFillInParticulars().contractor_contact_person,
            contractor_postal_code: this._nceService.getFillInParticulars().contractor_postal_code,
            supervisor_company_name: this._nceService.getFillInParticulars().supervisor_company_name,
            status: 'Awaiting Payment',
            status_description: 'NCE_XX',
            create_date: '',
            location_earthwork: this._nceService.getEarthworkDetails().location_earthwork,
            duration_from_date: this._nceService.getEarthworkDetails().duration_from_date,
            duration_to_date: this._nceService.getEarthworkDetails().duration_to_date,
            nature_proposed_earthwork: this._nceService.getEarthworkDetails().nature_proposed_earthwork,
            pipe_affected: this._nceService.getEarthworkDetails().pipe_affected,
            distance_work_area: this._nceService.getEarthworkDetails().distance_work_area,
            depth_earthwork: this._nceService.getEarthworkDetails().depth_earthwork,
            actual_start_date: this._nceService.getEarthworkDetails().actual_start_date,
            estimate_end_date: this._nceService.getEarthworkDetails().estimate_end_date,
            work_under_s29: this._nceService.getEarthworkDetails().work_under_s29,
            already_start: this._nceService.getEarthworkDetails().already_start,
            earthwork_remark: this._nceService.getEarthworkDetails().remarks,
            manholes_number: this._nceService.getEarthworkDetails().manholes_number,
            attachment: {
                sketch: this._fileService.getFileLists()[0],
                schedule: this._fileService.getFileLists()[1],
                support: this._fileService.getFileLists()[2],
                approval: [],
                waiting_for_diversion: [],
                rejected: [],
                briefing: [],
                appointment: [],
                plantmap: this._fileService.getMultipleFilesList(),
                newplantmap: this._fileService.getNewMultipleFilesList(),
                cancellation: [],
                finalApprovalApplication: [],
                finalApprovalApplicationForm: [],
                appointmentConfirmation: []
            },
            declare_name: this._nceService.getDeclaration().declare_name,
            declare_job_title: this._nceService.getDeclaration().declare_job_title,
            declare_phone_number: this._nceService.getDeclaration().declare_phone_number,
            term_conditions: 1,
            appointment_date: '',
            appointment_time: '',
            appointment_description: '',
            
            first_name: this._nceService.getFillInParticulars().contractor_first_name,
            last_name: this._nceService.getFillInParticulars().contractor_last_name,
            company_name: this._nceService.getFillInParticulars().contractor_company_name,
            phone_no: this._nceService.getFillInParticulars().contractor_telephone_no,
            address_line_1: this._nceService.getFillInParticulars().contractor_company_address,
            company_reg_no: this._nceService.getFillInParticulars().contractor_company_reg_no,
            apply_for_final_approval_contractor_name: '',
            apply_for_final_approval_bottom_contractor_designation: '',
            apply_for_final_approval_details: '',
            apply_for_final_approval_dates_1_completed: '',
            apply_for_final_approval_dates_1_date: '',
            apply_for_final_approval_dates_2_completed: '',
            apply_for_final_approval_dates_2_date: '',
            apply_for_final_approval_dates_3_completed: '',
            apply_for_final_approval_dates_3_date: '',
            apply_for_final_approval_dates_4_completed: '',
            apply_for_final_approval_dates_4_date: '',
            apply_for_final_approval_dates_5_completed: '',
            apply_for_final_approval_dates_5_date: '',
            apply_for_final_approval_dates_6_completed: '',
            apply_for_final_approval_dates_6_date: '',
            apply_for_final_approval_dates_7_completed: '',
            apply_for_final_approval_dates_7_date: '',
            last_status_change_date: '',
            appointmentHistory: [],
            rejection_remarks: [],
        }

        /*Object.assign(this._nceService.vDetailNCE, this._nceService.getFillInParticulars(), this._nceService.getEarthworkDetails(), this._nceService.getDeclaration());
        this._nceService.vDetailNCE.attachment = this._fileService.getFileLists();
        this._nceService.vDetailNCE.earthwork_remark = this._nceService.vEarthworkDetails.remarks;
        this._nceService.vDetailNCE.status = 'NCE_00';
        this._nceService.vDetailNCE.status_description = 'Awaiting Payment';*/
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/nce/components/preview.component.ts